import { fetchWrapRPC } from '../services/api';
import {
  DAILicenseService_GetDAILicenseMetadata,
  type GetDAILicenseMetadataRequest,
  type GetDAILicenseMetadataResponse,
} from './gen/ai/h2o/engine/v1/dai_license_service_pb';

export const getDAILicenseMetadata = (
  basePath: string,
  req: GetDAILicenseMetadataRequest = {},
  requestInit?: { signal?: AbortSignal }
): Promise<GetDAILicenseMetadataResponse> => {
  return fetchWrapRPC(DAILicenseService_GetDAILicenseMetadata, { basePath })(req, requestInit);
};
